export enum GuidanceBar {
  Updated = "Updated",
  Invalid = "Invalid",
  Warning = "Warning",
  None = "None",
}
